var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { StyledButton, StyledButtonStyle } from "ee-react-components";
import { process } from "../Process";
/**
 * A reusable button component that sends EventBus commands to a charger with debouncing.
 * Prevents rapid successive command sends by disabling the button for a specified duration.
 *
 * @template T - The type of the command entity.
 */
export function EventBusCommandButton(_a) {
    var _this = this;
    var chargerId = _a.chargerId, entityType = _a.entityType, commandEntity = _a.commandEntity, serialize = _a.serialize, text = _a.text, _b = _a.style, style = _b === void 0 ? StyledButtonStyle.Gray : _b, confirmMessage = _a.confirmMessage, _c = _a.debounceMs, debounceMs = _c === void 0 ? 1000 : _c;
    var _d = useAuth0(), user = _d.user, getAccessTokenSilently = _d.getAccessTokenSilently;
    var _e = useState(false), isDisabled = _e[0], setIsDisabled = _e[1];
    var sendCommand = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var accessToken, payload, requestBody, response, errorText, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Check confirmation if required.
                    if (confirmMessage && !confirm(confirmMessage)) {
                        return [2 /*return*/];
                    }
                    // Disable button for debounce period.
                    setIsDisabled(true);
                    setTimeout(function () { return setIsDisabled(false); }, debounceMs);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 2:
                    accessToken = _c.sent();
                    payload = serialize(commandEntity);
                    requestBody = {
                        chargerId: chargerId,
                        entityType: entityType,
                        payload: payload,
                        username: (_b = (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : user === null || user === void 0 ? void 0 : user.email) !== null && _b !== void 0 ? _b : "unknown",
                    };
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/commands/eventbus"), {
                            method: "POST",
                            body: JSON.stringify(requestBody),
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 3:
                    response = _c.sent();
                    if (!!response.ok) return [3 /*break*/, 5];
                    return [4 /*yield*/, response.text()];
                case 4:
                    errorText = _c.sent();
                    alert("Failed to send command: ".concat(errorText));
                    _c.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _c.sent();
                    console.error("Error sending command:", error_1);
                    alert("Error sending command: ".concat(error_1));
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [
        chargerId,
        entityType,
        commandEntity,
        serialize,
        confirmMessage,
        debounceMs,
        getAccessTokenSilently,
        user,
    ]);
    return (React.createElement(StyledButton, { text: text, style: style, onClick: sendCommand, disabled: isDisabled }));
}
